/* eslint-disable @typescript-eslint/no-explicit-any */
import { convertValueFormatTypeToOptions } from "./convert-value-format-type-to-options";
import { getChartKeyOptions } from "./get-chartKey-options";
import { Lang, getTranslation } from "@/data/translation";
import { ChartComponentParams, ChartKey } from "@/types/chart";
import { deepMerge } from "@/utils/deep-merge";
import { ChartOptions } from "chart.js";
import { isMobile, isTablet } from "react-device-detect";

export const getChartOptions = ({
  chartKey,
  locale,
  title,
  valueFormatType,
  currency,
}: {
  chartKey: ChartKey;
  locale: Lang;
  title?: string;
  valueFormatType?: ChartComponentParams["valueFormatType"];
  currency?: string;
}): ChartOptions<"bar" | "line"> => {
  const { t } = getTranslation({ lang: locale });
  const chartKeyOptions = getChartKeyOptions({ chartKey, valueFormatType, t });
  const baseOptions: ChartOptions<"bar" | "line"> = {
    aspectRatio: isMobile || isTablet ? 1 : 2,
    layout: {
      padding: 10,
    },
    interaction: {
      intersect: false,
      mode: "index" as const,
    },
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        padding: 10,
        bodySpacing: 5,
        boxPadding: 5,
      },
      title: {
        display: true,
        text: title,
        font: {
          size: 14,
          weight: "bold",
        },
      },
      subtitle: {
        display: !!currency,
        position: "bottom",
        text: currency ? t.currency({ currency }) : "",
        font: {
          size: 12,
          weight: "bold",
        },
      },
    },
  };

  let valueFormatTypeOptions = {};
  if (valueFormatType) {
    valueFormatTypeOptions = convertValueFormatTypeToOptions({
      valueFormatType,
    });
  }

  return deepMerge.apply(null, [
    baseOptions,
    chartKeyOptions,
    ...(Object.keys(valueFormatTypeOptions).length === 0
      ? []
      : [valueFormatTypeOptions]),
  ]);
};
